const dataDownload = {
  path: 'dataDownload',
  component: resolve => require(['../../../../pages/user/course/datadownload'], resolve)
}

export default dataDownload



// WEBPACK FOOTER //
// ./src/router/user/course/datadownload/index.js